<template>
  <div class="canteenApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading"    @resize="handleResize">
    <div class="header">
      <h3>距离您最近食堂</h3>
      <div class="li">
        <h2><i class="el-icon-location-outline"></i> 最美食堂中心店<font>0.03KM</font></h2>
      </div>
    </div>
    <div class="money">
      <span>账户总余额<font>0.00</font>元</span>
      <a @click="$router.push('recharge')">充值</a>
      <a @click="qrcode1">付款码</a>
    </div>

    <div class="h2">结算清单</div>
    <div class="pro" v-for="(item,i) in order" v-if="order.length >0">
      <div class="bussTitle">
        <el-image style="width:50px;height:50px; border-radius:5px;float:left" :src="baseUrl+item.logo" fit="cover"></el-image>
        <div class="name">
          <p>{{item.title}}</p>
          <p>编号：{{item.number}}</p>
        </div>
        <div class="status">{{item.status == 1 ? '待支付' : item.status == 2 ? '已支付' : '已完成'}}</div>
      </div>
      <div class="goods" v-for="(vo,j) in item.content">
        <div class="left">
          <el-image style="width:100%;height:50px; border-radius:5px;" :src="baseUrl+vo.img" fit="cover"></el-image>
        </div>
        <div class="right">
          <p>{{vo.title}}</p>
          <div class="num">{{vo.attr != undefined && vo.attr != '' ? vo.attr+'；' : '购买数量：'}}{{vo.num}}件</div>
          <div class="price">
            <i>￥</i><b>{{vo.rate.split(".")[0]}}</b>
            <i>.{{vo.rate.split(".")[1]}}</i>
            <div>￥{{vo.price}}</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="付款码" :show-close="true" :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false" :visible.sync="dialogVisible" width="400px">
      <div id="code" style="width:120px;margin:0 auto"></div>
    </el-dialog>
  </div>
</template>
<script>
  import $ from 'jquery'
  import QRCode from 'qrcodejs2'
  export default {
    data() {
      return {
        curHeight:0,
        dialogVisible:false,
        fullscreenLoading: false,
        baseUrl:'',
        isIphone:false,
        code:'',
        order:[],
        userData:[],
        bool:0
      };
    },
    beforeMount() {
      localStorage.removeItem('user');
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideAllNonBaseMenuItem');
        WeixinJSBridge.call('hideOptionMenu');
      });
      window.removeEventListener("resize", this.handleResize);
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      window.addEventListener("resize", this.handleResize);
      this.getOrder();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
        this.bool = (h >= 800 && this.isPhone() ? 1 : 0);
      },
      handleResize:function(e){
        if(this.curHeight < e.currentTarget.innerHeight && this.isPhone()){
          this.bool = 1;
        }else {
          if(this.curHeight >= 800 && this.curHeight == e.currentTarget.innerHeight && this.isPhone()){
            this.bool = 1;
          }else{
            this.bool = 0;
          }
        }
      },
      isPhone:function(){
        if (typeof window !== 'undefined' && window) {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
        }
        return false;
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      qrcode1:function(id,str){
        this.dialogVisible = true
        $("#code").html("");
        setTimeout(function () {
          let qrcode = new QRCode('code', {
              width: 120,
              height: 120, // 高度
              text: 'dfafse32' // 二维码内容
          })
        }, 100);
      },

      getOrder:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/userOrder',
          params:{
            user_id:8,
            status:2
          }
        }).then(function(response){
          that.fullscreenLoading = false
          var res = response.data.data;
          that.order = res
          
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getQquey();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .canteenApp{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  
  .canteenApp .header{
    height:70px;
    background:#fff;
    width:100%;
    border-bottom:1px solid #ececec
  }

  .canteenApp .header .li{
    width:100%;
    background:#fff;
  }
  .canteenApp .header h3{
    font-size:16px;
    padding:8px 0 0 3%
  }
  .canteenApp .header .li h2{
    width:92%;
    margin:0 auto;
    font-size:14px;
    padding-top:10px;
    font-weight:500;
    color:#555
  }
  .canteenApp .header .li h2 font{
    float:right;
    color:#f00;
    font-size:12px;
    margin-top:4px
  }
  .canteenApp .money{
    background:#fff;
    margin-top:1px;
    height:50px;
    line-height:50px;
  }
  .canteenApp .money span{
    padding-left:4%;
    color:#555;
  }
  .canteenApp .money span font{
    color:#796048;
    font-weight:bold
  }
  .canteenApp .money a{
    float:right;
    margin-right:15px;
    border:solid 1px #796048;
    color:#796048;
    height:32px;
    line-height:32px;
    width:60px;
    text-align:center;
    border-radius:32px;
    margin-top:9px
  }
  .canteenApp .h2{
    padding:20px 0 10px 0;
    color:#666;
    font-size:18px;
    text-align:center
  }
  .canteenApp .pro{
    background:#fff;
    display:block;
    width:92%;
    border-radius: 6px;
    margin:0 auto 15px auto;
    padding-bottom:15px
  }
  .canteenApp .pro .goods:after,.canteenApp .pro .bussTitle:after,.canteenApp .email:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .canteenApp .pro .bussTitle{
    width:92%;
    margin:0 auto;
    padding:15px 0 10px 0;
  }
  .canteenApp .pro .bussTitle img{
    width:50px;
    border-radius:5px;
    float:left;
  }
  .canteenApp .pro .bussTitle .name{
    float:left;
    width:68%;
    margin-left:2%
  }
  .canteenApp .pro .bussTitle .name p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-weight:bold
  }
  .canteenApp .pro .bussTitle .name p:last-child{
    font-size:13px;
    padding-top:8px;
    color:#999;
    font-weight:normal
  }
  .canteenApp .pro .bussTitle .status{
    float:right;
    font-size:13px;
    color:#666;
    margin-top:12px;
  }
  .canteenApp .goods{
    background:#f5f5f5;
    width:92%;
    margin:0 auto 1px auto;
  }
  .canteenApp .goods .left{
    float:left;
    width:16%;
    border-radius:5px;
    margin:4% 2% 2% 4%;
  }
  .canteenApp .goods .right{
    float:left;
    margin-top:4%;
    width:73%;
    position: relative;
  }
  .canteenApp .goods .right p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    width:78%
  }
  .canteenApp .goods .right .num{
    font-size: 13px;
    color: #999999;
    padding-top:12px;
  }
  .canteenApp .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    right:0;
    text-align:right
  }
  .canteenApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .canteenApp .goods .right .price b{
    color: #f00;
    font-size:16px;
    font-weight:600;
  }

  .canteenApp .goods .right .price i{
    color: #f00;
    font-size:13px;
    font-style:normal
  }
  
  .canteenApp .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }
</style>